import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IMember, ISelectMember, ISendRegistrationReminder } from "./types";

export function ApproveMember() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.approveMember}`, model),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getPendingApprovalCounts"] });
    },
  });
}

export function RejectMember() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.rejectMember}`, model),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getPendingApprovalCounts"] });
    },
  });
}

export function useDelete() {
  return useMutation({
    mutationFn: (id: number) =>
      api.get<number>(`${endpoints.member.delete}/${id}`),
  });
}

export function ApproveAllMembers() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (model: ISelectMember) =>
      api.post<number>(`${endpoints.member.approveallMembers}`, model),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getPendingApprovalCounts"] });
    },
  });
}

export function useAddMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.add}`, model),
  });
}

export function useEditMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.update}`, model),
  });
}

export function useSendRegistrationReminder() {
  return useMutation({
    mutationFn: (model: ISendRegistrationReminder) =>
      api.post<number>(`${endpoints.member.sendRegistrationReminder}`, model),
  });
}

export function useImportMemberExcel() {
  return useMutation({
    mutationFn: (excel: File) => {
      const formData = new FormData();
      formData.append("file", excel);
      return api.upload<{ fileBytes: string; insertedCount: number }>(
        `${endpoints.member.importMemebrExcel}`,
        formData
      );
    },
  });
}
